import { get } from 'lodash'
import { getLanguage, isLocaleExists } from 'src/common/browser'
import enUS from '../locales/en-US.json'

const context = require.context('../locales/', false, /\.json$/)

/**
 * 简易 i18n 处理
 * @param {string} key
 * @param {Array<number | string | boolean>} strings 模板传值
 * @returns {string}
 */
export function t(key, ...strings) {
  const language = getLanguage()
  const localeKey = isLocaleExists(language, context.keys())
  const defaultText = get(enUS, key, key)
  let str = defaultText
  if (localeKey) {
    str = get(context(localeKey), key, defaultText)
  }
  const data = [].concat(strings)
  return str.replace(/%s/g, () => `${data.shift() || ''}`)
}

export default context
